import { render, staticRenderFns } from "./FunctionalPositionInput.vue?vue&type=template&id=6220995a&"
import script from "./FunctionalPositionInput.vue?vue&type=script&lang=js&"
export * from "./FunctionalPositionInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports